import { Trans, useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { getHeroImage } from '../constants';
import { BoardLandingCtaButton } from './BoardLandingCtaButton';
export function BoardLandingHero() {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['boardLanding']);
  return <section aria-labelledby="board-landing-hero-heading"
  // 그라데이션 끝점 #F3F5F9 는 토큰이 아니다 — bg-neutral(#F5F6F9), bg-alternative
  // (#F0F2F6) 둘 다 값이 다르고, get_variable_defs 로 이 섹션의 Figma 변수를 조회해도
  // 이 색에 바인딩된 변수가 없다(디자이너가 토큰 없이 직접 찍은 값). 그대로 둔다.
  //
  // 하단 padding 만 min-[1025px] 에서 override 하고 상단은 그대로 두는 게 의도다 —
  // pt 는 751px 의 pt-3xl(64px) 을 그대로 물려받는데, 이 값이 Figma 데스크톱 프레임
  // (25528:9460)에서 실측한 상단 여백(64px)과 정확히 일치한다. pb 만 4xl(80px)로 더
  // 커지는 건 CTA 버튼과 이미지 사이 여백을 데스크톱에서 넓히기 위해서다(그 프레임의
  // 하단 여백도 80px 로 실측). 다른 6개 섹션의 대칭 padding(SECTION_PADDING)과 다른
  // 이 비대칭은 버그가 아니라 Hero 전용 값이라 그 상수를 쓰지 않는다.
  className="flex flex-col items-center gap-2xl bg-gradient-to-b from-white to-[#F3F5F9] px-[16px] pb-lg pt-2xl min-[751px]:px-[24px] min-[751px]:pb-2xl min-[751px]:pt-3xl min-[1025px]:px-[40px] min-[1025px]:pb-4xl" data-sentry-component="BoardLandingHero" data-sentry-source-file="BoardLandingHero.tsx">
      {/* Figma Title 그룹(제목+버튼)은 이미지와 별개로 gap-[30px] 를 쓴다 */}
      <div className="flex flex-col items-center gap-[30px]">
        {/* 줄바꿈이 로케일별 문구 길이에 달려 있어 `\n` + whitespace-pre-line 으로 둔다. */}
        <h1 id="board-landing-hero-heading" className="whitespace-pre-line text-center text-display-md-extrabold text-default">
          <Trans t={t} i18nKey="boardLanding:hero.title" components={{
          Strong: <strong className="text-strong" />
        }} data-sentry-element="Trans" data-sentry-source-file="BoardLandingHero.tsx" />
        </h1>

        <BoardLandingCtaButton location="hero" data-sentry-element="BoardLandingCtaButton" data-sentry-source-file="BoardLandingHero.tsx" />
      </div>

      <img src={getHeroImage(locale)} alt={t('boardLanding:hero.imageAlt')} width={1180} height={664} loading="eager" fetchPriority="high" className="h-auto w-full max-w-[1180px] rounded-lg" />
    </section>;
}